import React, { useState, useRef, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { errorCode } from '../../constants';
import { requestOtpChangeNumber } from '../../redux/actions/auth';
import { showToastNotif } from '../../redux/actions/notification';
import OtpModal from './OtpModal';
import PasswordModal from './passwordModal';

import styles from './profileForm.module.css';

const parseMobileNumber = (number) => {
  return number?.replace(/^\+62|^0/g, '');
};

const ProfileContact = () => {
  const isMounted = useRef(null);
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const [showPassModal, setShowPassModal] = useState(false);
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [sentOtp, setSentOtp] = useState(false);
  const [loading, setLoading] = useState(false);
  const { account, telco } = auth.user;
  const parseMobileNum = parseMobileNumber(account.mobile);
  const [mobile, setMobile] = useState(parseMobileNum || '');

  useEffect(() => {
    if (parseMobileNum) setMobile(parseMobileNum);
  }, [parseMobileNum]);

  const togglePassModal = () => {
    setShowPassModal(!showPassModal);
  };

  const toggleOtpModal = async () => {
    setShowOtpModal(!showOtpModal);
  };

  const handleChangeMobile = (e) => {
    const phone = e.target.value;
    setSentOtp(false);
    setMobile(phone);
  };

  const handleSendOtp = async () => {
    setLoading(true);
    try {
      await requestOtpChangeNumber('+62' + mobile);
      setShowOtpModal(!showOtpModal);
      setSentOtp(true);
    } catch (err) {
      const errCode = err?.response?.data?.error?.code;
      if (errCode === errorCode.PHONE_ALREADY_USED) {
        return dispatch(
          showToastNotif(
            'error',
            'Error: Number already used by another account.'
          )
        );
      }
      if (errCode === errorCode.INVALID_PHONE_NUMBER) {
        return dispatch(
          showToastNotif('error', 'Error: Invalid phone number.')
        );
      }
      dispatch(showToastNotif('error', 'Error sending OTP, please try again.'));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    isMounted.current = true;
  }, [isMounted]);

  return (
    <>
      {isMounted.current && (
        <PasswordModal open={showPassModal} onDismiss={togglePassModal} />
      )}
      <OtpModal
        open={showOtpModal}
        onDismiss={toggleOtpModal}
        phoneNumber={`+62${mobile}`}
      />
      <div className={styles.formContact}>
        <div className={styles.formInput}>
          <div className={styles.inputLabel}>Email</div>
          <div className={styles.columns}>
            <span>{account.email}</span>
            {account.emailVerifiedAt && (
              <span className={styles.emailHelper}>
                <b>Verified.</b> Thank you for verifying your email
              </span>
            )}
          </div>
        </div>
        <div className={styles.formInput}>
          <div className={styles.inputLabel}>Mobile No.</div>
          <div className={styles.phoneInput}>
            <div>
              <span data-addon>+62</span>
              <input
                onChange={handleChangeMobile}
                value={mobile}
                autoComplete='off'
                list='autocompleteOff'
                type='number'
                name='phone'
                id='phone'
              />
            </div>
            {mobile && (
              <button
                disabled={loading}
                onClick={sentOtp ? toggleOtpModal : handleSendOtp}
              >
                Save
              </button>
            )}
          </div>
        </div>
        <div className={styles.formInput}>
          <div className={styles.inputLabel}>Password</div>
          <div data-password-hide>
            **************
            {!telco && (
              <span className={styles.passwordEdit} onClick={togglePassModal} />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ProfileContact;
